import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Tooltip } from "@mui/material";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import { useAppReduxDispatch } from "hooks/reduxHooks";
import {
  NucleofectionPlateInfoState,
  NucleofectionToolActions,
} from "../../state";

interface WashVolProps {
  nucPlateInfo: NucleofectionPlateInfoState;
  width: number;
}

export const WashVol = ({ nucPlateInfo, width }: WashVolProps) => {
  const dispatch = useAppReduxDispatch();

  const minWashVol = nucPlateInfo.minOperatingVol;
  const maxWashVol = nucPlateInfo.operatingVol - nucPlateInfo.minOperatingVol;
  const washVolOutOfRange =
    nucPlateInfo.washVol < minWashVol || nucPlateInfo.washVol > maxWashVol;

  const hasError = nucPlateInfo.numberOfWashes > 0 && washVolOutOfRange;
  const isDisabled =
    nucPlateInfo.numberOfWashes === 0 || nucPlateInfo.labwareTypeCode === "";

  const handleWashVolChanged = (washVol: number) => {
    dispatch(NucleofectionToolActions.UPDATE_NUC_WASHVOL({ washVol }));
  };
  return (
    <NumberField
      style={{ width: `${width}%`, marginTop: "10px" }}
      id="wash-vol"
      label={
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          Wash Vol (µL)
          <Tooltip
            arrow
            placement="top"
            title="Volume per wash, after post-Nucleofection topup and transfer to int plate."
          >
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      }
      value={nucPlateInfo.washVol}
      onChange={(value) => handleWashVolChanged(Number(value))}
      disabled={isDisabled}
      hasError={hasError}
      errorMessage={`Wash Vol must be between ${minWashVol}μl and ${maxWashVol}μl`}
    />
  );
};
